import React, { useEffect, useRef } from 'react';
import { logger } from '@fiverr-private/obs';
import { loadComeetScript, initComeet } from '../../../lib/comeet/loadComeetScript';
import type { ComeetEmbedConfig } from '../../../lib/comeet';
import { comeetSocial } from './styles.ve.css';

interface ComeetSocialProps {
    positionUid: string;
    comeetEmbedConfig: ComeetEmbedConfig;
}

export const ComeetSocial = ({ positionUid, comeetEmbedConfig }: ComeetSocialProps) => {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const el = ref.current;
        if (!el) {
            return;
        }
        const s = document.createElement('script');
        s.type = 'comeet-social';
        Object.assign(s.dataset, {
            socialEmployees: 'true',
            positionUid,
            cssCache: 'false',
            socialNetworks: 'basic',
            socialShowTitle: 'true',
        });
        el.appendChild(s);
        loadComeetScript()
            .then(() => initComeet(comeetEmbedConfig))
            .catch(logger.error);
        return () => {
            el.replaceChildren();
        };
    }, [positionUid, comeetEmbedConfig]);

    return <div className={comeetSocial} ref={ref} />;
};
